import { m, AnimatePresence } from 'framer-motion';
import { REACTION_EMOJIS } from '@brainfart/shared';

// The tappable bar of emoji — fixed bottom-center during a live round.
export function ReactionBar({ onReact }: { onReact: (emoji: string) => void }) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 'max(1rem, env(safe-area-inset-bottom))',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 60,
        display: 'flex',
        gap: '0.35rem',
        padding: '0.4rem 0.5rem',
        borderRadius: '100px',
        background: 'rgba(20,18,36,0.75)',
        border: '1px solid #2E2B45',
        backdropFilter: 'blur(8px)',
      }}
    >
      {REACTION_EMOJIS.map(emoji => (
        <m.button
          key={emoji}
          onClick={() => onReact(emoji)}
          whileTap={{ scale: 1.4 }}
          whileHover={{ scale: 1.2 }}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.5rem',
            lineHeight: 1,
            padding: '0.15rem',
          }}
          aria-label={`React ${emoji}`}
        >
          {emoji}
        </m.button>
      ))}
    </div>
  );
}

// The floating overlay — each reaction drifts up and fades. Non-interactive so
// it never blocks the answer buttons underneath.
export function ReactionsLayer({ reactions }: { reactions: { id: string; emoji: string; x: number }[] }) {
  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 55, overflow: 'hidden' }}>
      <AnimatePresence>
        {reactions.map(r => (
          <m.div
            key={r.id}
            initial={{ opacity: 0, y: 0, scale: 0.5 }}
            animate={{ opacity: [0, 1, 1, 0], y: -240, scale: [0.5, 1.2, 1, 1], x: [0, 12, -12, 6] }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2.5, ease: 'easeOut' }}
            style={{
              position: 'absolute',
              left: `${r.x}vw`,
              bottom: '5rem',
              fontSize: '2.25rem',
              filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.4))',
            }}
          >
            {r.emoji}
          </m.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
